import Pagination from "@shared/v2/Pagination";

interface TemplatesPaginationProps {
  currentPage: number;
  totalPages: number;
  /** Receives `null` for page 1 so it can be dropped from the URL. */
  onGoToPage: (page: number | null) => void;
}

const TemplatesPagination = ({ currentPage, totalPages, onGoToPage }: TemplatesPaginationProps) => {
  if (totalPages <= 1) return null;

  return (
    <div className="tw-flex tw-justify-center tw-p-[12px]">
      {/* @ts-expect-error props */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onGoToPage={(page: number) => onGoToPage(page > 1 ? page : null)}
      />
    </div>
  );
};

export default TemplatesPagination;
